import Vue from "vue";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";

if (typeof window.wobbleminor !== 'undefined' && typeof window.wobbleminor.e34rnl !== 'undefined' && !window.wobbleminor.e34rnl.i) {
    const structure = window.wobbleminor.e34rnl;

    Sentry.init({
        Vue: Vue,
        dsn: structure.k,
        debug: structure.d,
        integrations: [new Integrations.BrowserTracing({
            tracingOrigins: [
                window.location.host,
                /^\//
            ]
        })],
        tracingOptions: {
            trackComponents: true,
        },
        environment: process.env.NODE_ENV,
        release: APP_VERSION
    });

    Sentry.setContext('versions', {
        frontend: APP_VERSION,
        backend: structure.sv
    });

    window.wobbleminor.e34rnl.i = true;
}
